module.exports = __webpack_public_path__ + "static/media/food.0ae3a310.jpeg";